import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private errorToastSubject = new Subject<any>();
  errorToastObservable = this.errorToastSubject.asObservable();

  constructor() {
    //Constructor
  }
  errorMessage(message: any) {
    this.errorToastSubject.next(message)
  }
  
  error(message: string) {
    let errorMessage = '';
    // try to parse to JSON, if fails mean pure string
    try {
      const error = JSON.parse(message);
      errorMessage = this.handleError(error);
    } catch (e) {
      errorMessage = 'Server unavailable: ' + message;
    }
    this.errorToastSubject.next(errorMessage);
    window.scrollTo(0, 0);
  }

  handleError(error: HttpErrorResponse): string {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent && error.error.type !== 'error') {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${error.error.message}`;
      console.error('An error occurred:', error.error.message);
      return errorMessage;
    } else if (error.status === 0) {
      // CONNECTION ERROR
      errorMessage =
        `Backend returned code ${error.status}, ` +
        `body was: ${JSON.stringify('Connection Failure')}`;
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${JSON.stringify(error.message)}`
      );
      return errorMessage;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage =
        `Backend returned code ${error.status}, ` +
        `body was: ${this.decodeBackendError(error.error)}`;
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${JSON.stringify(error.error)}`
      );
      return errorMessage;
    }
  }

  decodeBackendError(err) {
    if (err && err.messagea) {
      return err.message;
    } else {
      return JSON.stringify(err);
    }
  }
}
